import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "textarea" }
const _hoisted_3 = { class: "action" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Divider = _resolveComponent("Divider")
  const _component_TextArea = _resolveComponent("TextArea")
  const _component_Button = _resolveComponent("Button")
  const _component_Popover = _resolveComponent("Popover")

  return (_openBlock(), _createBlock(_component_Popover, {
    modelValue: $data.visible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.visible) = $event)),
    placement: $props.placement,
    width: $options.c_width,
    teleported: $options.c_teleported,
    "popper-class": $options.c_popper_class,
    mask: _ctx.$responsive.mobile,
    onHide: $options.onHide
  }, {
    reference: _withCtx(() => [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = (...args) => ($options.onShow && $options.onShow(...args)))
      }, [
        _renderSlot(_ctx.$slots, "default", { visible: $data.visible })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "feedback",
        style: _normalizeStyle({height: $props.height})
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_Icon, {
            icon: "message-text-square-02",
            width: "2.4rem",
            height: "2.4rem",
            stroke: "var(--gray-500)"
          }),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title" }, "Feedback", -1 /* HOISTED */)),
          _createVNode(_component_Icon, {
            class: "pointer",
            style: {"margin-left":"auto"},
            icon: "x-close",
            width: "2rem",
            height: "2rem",
            stroke: "var(--gray-500)",
            onClick: $options.onClose
          }, null, 8 /* PROPS */, ["onClick"])
        ]),
        ($props.divider)
          ? (_openBlock(), _createBlock(_component_Divider, {
              key: 0,
              m: "0 0 1.2rem"
            }))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_TextArea, {
            modelValue: $data.message,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.message) = $event)),
            maxlength: 2048,
            rows: $props.rows,
            placeholder: "Add your feedback here"
          }, null, 8 /* PROPS */, ["modelValue", "rows"])
        ]),
        ($props.divider)
          ? (_openBlock(), _createBlock(_component_Divider, {
              key: 1,
              m: "1.2rem 0 0"
            }))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Button, {
            disabled: !$options.can_send,
            primary: "",
            tiny: "",
            onClick: $options.onSend
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Send")
            ])),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled", "onClick"])
        ])
      ], 4 /* STYLE */)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["modelValue", "placement", "width", "teleported", "popper-class", "mask", "onHide"]))
}